import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Row, Col } from 'react-bootstrap';
import turf from '@turf/turf';

import { VIDEO_TYPES } from '../../../api/Videos/Videos';

import PageHeader from '../../atoms/PageHeader';
import ProjectItemsListContainer from '../../containers/ProjectItemsListContainer';
import TableListContainer from '../../containers/TableListContainer';

const { defaultMapCenter } = Meteor.settings.public;

const DASHBOARD_DEFAULT_LOCATION = turf.point(turf.getCoord(defaultMapCenter), { zoom: 1 });

const Dashboard = ({ ...rest }) => (
  <>
    <PageHeader>
      <h4 className="mr-auto">Dashboard</h4>
    </PageHeader>
    <Row>
      <Col xs={12}>
        <TableListContainer
          Page={props => (
            <ProjectItemsListContainer
              project={{ mapLocation: DASHBOARD_DEFAULT_LOCATION }}
              hasMap
              isPublic
              types={VIDEO_TYPES.properties}
              {...props}
              {...rest}
            />
          )}
        />
      </Col>
    </Row>
  </>
);

export default Dashboard;
